var contentMenu = (function () {

    function init() {
        
        let contentmenu_exists = document.getElementsByClassName('page-contents-container');

        if (contentmenu_exists.length > 0) {
            bindUI();
        }

    }

    function bindUI() {
      const sections = document.querySelectorAll(".page-content [id]");

        if (sections.length > 0) {
            bindEvents(sections);
        }

    }


    /*
    * Bind the events
    * */
    function bindEvents(sections) {

      window.addEventListener('scroll',(event) => {
        navHighlighter(sections);
      });

    }

    function navHighlighter(sections) {

        let scrollY = window.pageYOffset;

        // Now we loop through sections to get height, top and ID values for each

        Array.prototype.forEach.call(sections, function (current) {

          //Find object on page
          let currentItem = document.getElementById(current.id);

          // Check if ID exits in side menu
          let menuItems = document.querySelector('.page-contents-container ul li a[href*="#' + currentItem.id + '"]');
          
          if (menuItems) {

            const sectionHeight = currentItem.offsetHeight;
            const sectionTop = (currentItem.getBoundingClientRect().top + window.pageYOffset) - 20;

            if (
              scrollY > sectionTop &&
              scrollY <= sectionTop + sectionHeight
            ){
              document.querySelector(".content-menu-item a[href*=" + current.id + "]").classList.add("active");
            } else {
              document.querySelector(".content-menu-item a[href*=" + current.id + "]").classList.remove("active");
            }

          }

        });

      }

    init();

    return self;

}());
